if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;


      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }


          // Функция для обновления отсчета времени на странице
          function updateCountdown() {
            // Получаем текущее время и время, через 15 минут
          var currentTime = new Date().getTime();
          var fifteenMinutesLater = new Date(currentTime + (15 * 60 * 1000)).getTime();

          // Получаем сохраненное время начала обратного отсчета из localStorage
          var savedStartTime = localStorage.getItem('countdownStartTime');

          // Если сохраненное время начала обратного отсчета существует, используем его
          if (savedStartTime) {
            fifteenMinutesLater = parseInt(savedStartTime) + (15 * 60 * 1000);
          } else {
            // Если сохраненного времени нет, сохраняем текущее время в localStorage
            localStorage.setItem('countdownStartTime', currentTime);
          }

          // Сохраняем время окончания обратного отсчета в localStorage
          localStorage.setItem('countdownEndTime', fifteenMinutesLater);
            // Получаем время окончания обратного отсчета из localStorage
            var countdownEndTime = localStorage.getItem('countdownEndTime');
            
            // Если время не установлено, выходим из функции
            if (!countdownEndTime) {
              return;
            }
            
            // Получаем разницу между текущим временем и временем окончания обратного отсчета
            var diff = countdownEndTime - new Date().getTime();
            
            // Если время истекло, очищаем localStorage
            if (diff <= 0 || document.querySelector('.shoping-bar').classList.contains('stop')) {
              document.querySelector('.shoping-bar').classList.add('hide');
              localStorage.removeItem('countdownStartTime');
              localStorage.removeItem('countdownEndTime');
              return;
            }
            
            // Преобразуем разницу времени в минуты и секунды
            var minutes = Math.floor(diff / 1000 / 60);
            var seconds = Math.floor((diff / 1000) % 60);

            // Добавляем ноль перед числом, если количество секунд меньше 10
            if (seconds < 10) {
              seconds = '0' + seconds;
            }
            
            // Обновляем отображение времени на странице
            document.getElementById('countdown').innerHTML = minutes + ':' + seconds;
            
            // Обновляем отсчет каждую секунду
            setTimeout(updateCountdown, 1000);
          }


          let startTime = Date.now();
          let endTime = startTime + 15 * 60 * 1000; // 15 minutes in milliseconds
          
          // Saving the start and end times in the local storage
          localStorage.setItem('countdownStartTime', startTime);
          localStorage.setItem('countdownEndTime', endTime);

          document.querySelector('.shoping-bar').classList.remove('stop')

          
          updateCountdown();

          let clickCount = sessionStorage.getItem('clickCount') || 0;
          if (clickCount != 2) {
            console.log(clickCount);
            document.querySelector('.shoping-bar').classList.remove('hide');
          }

          fetch(window.location.href)
          .then(response => response.text())
          .then(html => {
            const parser = new DOMParser();
            const htmlDoc = parser.parseFromString(html, 'text/html');
            const bar = htmlDoc.querySelector('.shoping-bar__product');
           
              document.querySelector('.shoping-bar__product').innerHTML = '';
              document.querySelector('.shoping-bar__product').appendChild(bar);
          })
          .catch(error => console.log(error));



        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
